export interface WaiverRecordReference {
  /** What the id is, e.g. "DocuSign envelope". */
  label: string
  /** The bare id, without its `source:` prefix. */
  id: string
}

const clean = (value?: string | null): string => value?.trim() || ''

/**
 * Splits an `externalReference` such as `docusign:<envelope id>` into a
 * labelled id. A value with no `source:` prefix is kept whole.
 */
export const parseWaiverRecord = (
  reference?: string | null
): WaiverRecordReference | null => {
  const value = clean(reference)
  const separator = value.indexOf(':')
  const source = separator > 0 ? value.slice(0, separator).toLowerCase() : ''
  const id = separator > 0 ? value.slice(separator + 1).trim() : value
  if (!id) {
    return null
  }

  return {
    label: source === 'docusign' ? 'DocuSign envelope' : 'Record',
    id,
  }
}

/**
 * The tag's label with "Waiver" in it ("Signed" → "Waiver signed"), for a pill
 * that stands on its own, without a column header to say what it is about.
 */
export const waiverSummaryLabel = (label: string): string =>
  /^waiver\b/i.test(label)
    ? label
    : `Waiver ${label.charAt(0).toLowerCase()}${label.slice(1)}`
